import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    overflow: 'auto',
  },
  [theme.breakpoints.up('md')]: {
    overflow: 'hidden',
  },
}));

export const InnerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderTop: `1px solid ${theme.palette.grey[700]}`,
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    flexDirection: 'column',
  },
  [theme.breakpoints.up('md')]: {
    height: '100%',
    flexDirection: 'row',
  },
}));
